import React, { Component, Fragment } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
} from "reactstrap";
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import ButtonToggle from "../controls/_ButtonToggle";
import * as common from "../../lib/common"
import * as constants from "./constants"

export default class OrderApproveListCfm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasChanged: false,
      approveInfor: {},
    }
  }
  valueChange = (e, name) => {
    let approveInfor = this.state.approveInfor
    switch (name) {
      case 'da_thanh_toan':
          approveInfor[name] = e
        break;
      case 'noi_xuat':
          approveInfor[name] = e.target.value
        break;
      case 'ghi_chu':
          approveInfor[name] = e.target.value
        break;
    }
    this.setState({hasChanged: true, approveInfor: approveInfor})
  }
  onClose = () => {
    this.setState({approveInfor: {}})
    this.props.onClose()
  }
  render() {
    const { 
      approveInfor 
    } = this.state

    const {
      requesting,
      ordersChecked,
      isAvailableApprove,
      errors,
      messages,
    } = this.props


    const getOrdersChecked = (items) => {
      return items.map((item, idx) => {
        return (
          <div key={idx} className="d-sm-inline pl-1 pr-1">{item.MaDonHang}</div>
        )
      });
    }
    return (
      <div className="animated fadeIn">
        <Modal isOpen={this.props.isApprove} className="modal-md" modalClassName={"order-approve-cfm"}>
          <ModalHeader>Hoàn thành danh sách đơn hàng</ModalHeader>
          <ModalBody>
            <div className="col-sm-12  mb-1 pl-0 pr-0">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend">
                  <span className="input-group-text">Hoàn thành cho đơn hàng</span>
                </div>
                <div className="border mb-1 pt-1 pl-1 pr-1">
                  {getOrdersChecked(ordersChecked)}
                </div>
              </div>
            </div>
            <div className="col-sm-12  mb-1 pl-0 pr-0">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell" htmlFor="da_thanh_toan">
                  <span className="input-group-text">Đã thanh toán</span>
                </div>
                <div className="mb-12 display-table-cell">
                  <ButtonToggle name="da_thanh_toan" handleChange={e => this.valueChange(e, "da_thanh_toan")} isChecked={approveInfor.da_thanh_toan || ''} />
                </div>
              </div>
            </div>
            <div className="col-sm-12  mb-1 pl-0 pr-0">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell">
                  <span className="input-group-text" htmlFor="noi_xuat">Nơi xuất</span>
                </div>
                <div className="display-table-cell">
                  <Input name="noi_xuat" type="textbox" name="ghi_chu" value={approveInfor.noi_xuat || ''} onChange={e => this.valueChange(e, "noi_xuat")} />
                </div>
              </div>
            </div>
            <div className="col-sm-12  mb-1 pl-0 pr-0">
              <Input type="textarea" maxLength={250} name="ghi_chu" placeholder="Ghi chú" value={approveInfor.ghi_chu || ''} onChange={e => this.valueChange(e, "ghi_chu")} />
              <div className="clearfix"></div>
            </div>
            <div className="col-sm-12 pl-0 pr-0">
              {!requesting && !!errors.length && (
                <Errors message="Failure to signup due to:" errors={errors} />
              )}
              {!requesting && !!messages.length && (
                <Messages messages={messages} />
              )}
            </div>
            <div className="col-sm-12 pl-0 pr-0">
              <div className="btn-group float-right" role="group">
                <Button disabled={!isAvailableApprove} className="btn btn-success mr-1" onClick={() => this.props.approveOrdersClick(approveInfor, ordersChecked)}>
                  <i className="fa fa-check"></i><span className="d-none d-sm-inline">&nbsp;Hoàn thành</span></Button>
                <Button className="btn btn-secondary" onClick={() => this.onClose()}>
                  <i className="fa fa-arrow-left"></i><span className="d-none d-sm-inline">&nbsp;Đóng</span></Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Orders/_OrderApproveListCfm.js